import React from 'react';

interface Props {
  title: React.ReactNode;
  lead?: React.ReactNode;
  /** Small label above the title (e.g. a contract chip). */
  kicker?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

/** Compact page header — one h1, one short lead, optional actions. */
const PageHeader: React.FC<Props> = ({ title, lead, kicker, actions, className = '' }) => (
  <header className={`pt-5 pb-4 sm:pt-8 sm:pb-6 ${className}`}>
    {kicker && <div className="mb-2">{kicker}</div>}
    <h1 className="text-2xl sm:text-4xl font-bold tracking-tight text-white">{title}</h1>
    {lead && <p className="mt-2 text-sm sm:text-base text-secondary-300">{lead}</p>}
    {actions && <div className="mt-4 flex flex-col sm:flex-row gap-3">{actions}</div>}
  </header>
);

export default PageHeader;
